import React from 'react';
import { motion } from 'framer-motion';
const stories = [{
  title: 'Not a home theatre.',
  subtitle: 'A private cinema.',
  desc: 'Every seat. Every frequency. Every frame — precisely engineered.',
  colorClass: 'text-[#6366F1]',
  bgGradient: 'radial-gradient(circle at center, rgba(99,102,241,0.1) 0%, transparent 70%)',
  lineColor: 'bg-[#6366F1]'
}, {
  title: 'Music that follows you.',
  subtitle: 'Not rooms.',
  desc: 'From morning routines to late-night listening — your home moves with you.',
  colorClass: 'text-[#EC4899]',
  bgGradient: 'radial-gradient(circle at center, rgba(236,72,153,0.1) 0%, transparent 70%)',
  lineColor: 'bg-[#EC4899]'
}, {
  title: 'The outdoors, reimagined.',
  desc: 'Weatherproof sound, hidden lighting, and seamless control — designed into your landscape.',
  colorClass: 'text-[#F59E0B]',
  bgGradient: 'radial-gradient(circle at center, rgba(245,158,11,0.1) 0%, transparent 70%)',
  lineColor: 'bg-[#F59E0B]'
}, {
  title: 'The intelligence behind everything.',
  desc: 'Enterprise-grade networking, security, and control — designed for reliability and invisibility.',
  colorClass: 'text-[#10B981]',
  bgGradient: 'radial-gradient(circle at center, rgba(16,185,129,0.1) 0%, transparent 70%)',
  lineColor: 'bg-[#10B981]'
}];
export function CinematicStory() {
  return <section className="bg-void" data-id="element-181">
      {stories.map((story, idx) => <div key={idx} className="relative min-h-[70vh] flex items-center justify-center px-6 py-24" data-id="element-182">
          {/* Top Divider Line */}
          <div className={`absolute top-0 left-1/2 -translate-x-1/2 w-24 h-px ${story.lineColor} opacity-50`} data-id="element-183" />

          <div className="absolute inset-0 film-grain opacity-30 pointer-events-none z-10" data-id="element-184"></div>
          <div className="absolute inset-0 pointer-events-none" style={{
        background: story.bgGradient
      }} data-id="element-185"></div>

          <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-20%'
      }} transition={{
        duration: 1
      }} className="max-w-4xl mx-auto text-center relative z-20" data-id="element-186">
            <h2 className={`text-display font-serif mb-6 leading-tight ${story.colorClass}`} data-id="element-187">
              {story.title}
            </h2>
            {story.subtitle && <h3 className="text-headline font-serif text-platinum mb-8" data-id="element-188">
                {story.subtitle}
              </h3>}
            <p className="text-xl text-silver font-light max-w-2xl mx-auto leading-relaxed" data-id="element-189">
              {story.desc}
            </p>
          </motion.div>
        </div>)}
    </section>;
}